<template>
  <main id="mywork">
    <waterfall/>
  </main>
</template>

<script>
  import Waterfall from 'components/Waterfall'
  export default {
    components: {
      Waterfall
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/MyWork.vue